<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="point_block_obj.label"
          />
        </div>
        <div class="col-4">
          <label for="PointBlockCd" class="form-label">ブロックコード</label>
          <input
            type="text"
            class="form-control"
            id="Point_blockCd"
            placeholder="地域コード"
            v-model="point_block_obj.point_block_cd"
          />
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="point_block_obj.sort"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'

export default {
  name: 'PointBlockDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'ポイントブロックデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      point_block_obj: {}
    }
  },
  components: {
    BsPageTitle,
    // BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadPointBlockObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/point_block/lists',
        params
      )
        .then(async response => {
          console.log('loadType', response)
          this.point_block_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.point_block_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.point_block_obj)
      return this.$store
        .dispatch('updateBasic', {
          data: this.point_block_obj,
          target: 'point_block'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadPointBlockObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({})
  },

  async created() {
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadPointBlockObj()
      this.btnLabel = '更新'
    } else {
      this.point_block_obj = {
        id: 0,
        label: '',
        point_block_cd: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'ポイントブロックデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
